import _ from "ES/lib/lodash";
import React from "ES/lib/react";
import getOfferStatusForJob, {OFFER_STATII} from "../../utils/getOfferStatusForJob";

require("./MPJobProgressBar.less");


export default React.createClass({
    render: function () {
        let sid = this.props.sid;
        let event = this.props.event;
        let startataccepted = _.get(this.props, "startataccepted", false);

        let offer_status = getOfferStatusForJob.statusForEvent(event, sid, false); //[null, "unread message", "waiting client", "waiting you", "offer accepted", "deposit paid", "paid in full", "event completed", "reviewed"]; //order of priority is important; the names are magic (if you change them you'll need to search & replace)

        return <div className="MPJobProgressBar no-select">
            <ul>
                {!startataccepted && <li className="active"><span className="title">Shortlisted</span><span className="circle"></span></li>}
                {!startataccepted && <li className={(_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "waiting client")) ? "active" : ""}><span className="title">Offer Pending</span><span className="circle"></span></li>}
                <li className={(_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "offer accepted")) ? "active" : ""}><span className="title">Offer Accepted</span><span className="circle"></span></li>
                <li className={(_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "deposit paid")) ? "active" : ""}><span className="title">Deposit Paid</span><span className="circle"></span></li>
                <li className={(_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "paid in full")) ? "active" : ""}><span className="title">Balance Paid</span><span className="circle"></span></li>
            </ul>
        </div>;
    }
});



// WEBPACK FOOTER //
// ./src/components/marketplace/MPJobProgressBar.js